import { Box, SegmentedToggle } from "@wix/design-system";
import React from "react";
const ActionBar = ({ selectedId, options, onChange }) => {
  return /* @__PURE__ */ React.createElement(Box, { padding: "16px" }, /* @__PURE__ */ React.createElement(SegmentedToggle, { selected: selectedId, onClick: (_, value) => onChange(value) }, options.map((option) => /* @__PURE__ */ React.createElement(SegmentedToggle.Button, { key: option.id, value: option.id }, /* @__PURE__ */ React.createElement(Box, { align: "center", verticalAlign: "middle" }, option.icon)))));
};
export {
  ActionBar
};
//# sourceMappingURL=action-bar.js.map
